// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactTag_container__3g74_","tags":"ContactTag_tags__3DC1n","tagPill":"ContactTag_tagPill__3aNvg"};